import { useEffect } from 'react';

import { debounce } from 'debounce';
import { useAppSelector } from 'store/store-hooks';
import { EMPTY_CELL, selectClipData } from 'components/app/editor/_mediator/editor.slice';

import { SUBMIT_DELAY } from '../_pan-zoom.params';
import { usePanZoomContext } from '../_pan-zoom.provider';
import { usePanZoomFormat } from './use-pan-zoom-format';

export const usePanZoomStore = () => {
  const clipData = useAppSelector(selectClipData);
  const keyFrameIndex = useAppSelector((state) => state.editor.panZoomKeyFrameIndex);
  const activeClip = useAppSelector((state) => state.editor.activeClip);

  const { panZoomRotate } = usePanZoomContext();
  const { fromClipConfig, toClipConfig } = usePanZoomFormat();

  useEffect(() => {
    if (activeClip === EMPTY_CELL) return;
    fromClipConfig();
  }, [clipData?.config.panZoomRotate[keyFrameIndex]]);

  useEffect(() => {
    debounce(toClipConfig, `panZoom__${activeClip}_${keyFrameIndex}`, SUBMIT_DELAY);
  }, [panZoomRotate]);
};
